// IconComponent.jsx
import React from 'react';

function IconComponent({ iconName }) {
  return <i data-icon-before={ iconName }></i>;
}

export default IconComponent;
